module.exports = __webpack_public_path__ + "img/fontcontrol_en.330c13d.jpg";